// 页面抽离统一管理
const baseConf = {
  // 基础品牌信息
  name: 'JashnWear',
  companyName: 'VETRIONE TECHNOLOGIES PRIVATE LIMITED',
  address: 'HubFive Coworkz, No 104,  Developed Plots,  Origin Biulding, 2nd Floor, North Wing, Industrial Estate, Perungudi-600096',
  email: 'support@jashnwear.shop',
  
  // 主题配置
  // JashnWear 色彩围绕节庆、聚会和高饱和民族融合服饰展开
  theme: {
    color: '#b91c3b',      // 主色：石榴红，用于品牌按钮和关键强调
    secondary: '#f0a51a',  // 次色：金盏花橙，承接节庆与派对氛围
    success: '#14715f',    // 成功色：孔雀绿，和高饱和服饰视觉匹配
    warning: '#d97706',    // 提示色：暖金色，用于价格与促销提示
    danger: '#9f1239',     // 危险色：深玫红，用于错误和删除反馈
    info: '#3b5b92'        // 信息色：靛蓝，用于说明和辅助状态
  },
  // 定制化配-倾向单独的配置-如首页模块文本色
  custom: {
    // 首页模块介绍文本
    homeIntroduceTitle: '#141312',
    homeIntroduceTitleFont: 'MyriadPro-BoldIt, sans-serif',
    homeIntroduceBg: '#fff7ed', // 介绍模块背景色，保持暖色节庆氛围
    homeSwiperBg: '#fff1f2', // 轮播图背景色，轻玫红承接品牌主色
    homeNavBtn: '#b91c3b' // 首页导航块按钮色
  },
  // SEO配置
  seo: {
    title: 'JashnWear - Festive and Party Wear for India',
    description: 'JashnWear is a festive and party wear e-commerce brand for India, offering vibrant traditional fusion clothing for festivals, family gatherings, and social parties.',
    keywords: 'JashnWear, festive wear India, party wear, traditional fusion fashion, Diwali outfit, Holi fashion, social gathering outfits'
  },
  // 社交媒体
  social: {
    facebook: 'https://facebook.com/jashnwear',
    instagram: 'https://instagram.com/jashnwear',
    twitter: 'https://twitter.com/jashnwear',
    youtube: 'https://youtube.com/jashnwear'
  },
  
  // 功能开关
  features: {
    enableChat: true,
    enableWishlist: true,
    enableCompare: true,
    enableReviews: true,
    enableNewsletter: true
  }
};

const formatConf = (conf) => {
  const cssVars = {};
  
  // 处理主题配置
  Object.entries(conf.theme).forEach(([key, value]) => {
    // 将驼峰命名转换为中划线命名,例如: primaryColor -> --theme-primary-color
    cssVars[`--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  // 处理自定义配置
  Object.entries(conf.custom).forEach(([key, value]) => {
    cssVars[`--tc-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  return {
    ...conf,
    cssVars
  };
};

export default formatConf(baseConf);
